module.exports = __webpack_public_path__ + "static/media/cusense_name.ef4f25f5.svg";